import { getMembers } from "@repository/membersRepository";
import { useQuery } from "react-query";

const useFetchMembers = (lang: string) => {
  const { data, isLoading, isError } = useQuery(
    ["members"],
    () => getMembers(lang),
    {
      refetchInterval: 1000 * 60 * 60,
    }
  );
  return { members: data, isLoading, isError };
};

export default useFetchMembers;
